import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [ToolbarModule, ButtonModule, CommonModule],
  templateUrl: './toolbar.component.html',

})
export class ToolbarComponent {
  @Input() createdAt: string = '';
  @Input() updatedAt: string = '';
  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  handleEdit() {
    this.edit.emit();
  }

  handleDelete() {
    this.delete.emit();
  }
}
